import { useCallback, useEffect, useState } from "react";
import { Button, Col, Container, Form, ListGroup, Row } from "react-bootstrap";

// css
import styles from "./addForm.module.scss";
import { FieldArray, Formik } from "formik";
import { Link, useNavigate, useParams } from "react-router-dom";
import { NOTES_TABLE } from "config/paths";
import AppInputField from "components/shared/FormComponents/AppInputField";
import { Breadcrumbs, RequiredFieldAstrick } from "components/Common/Common";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { dateFormat, isValidValue, NoRecordMessage, ReportsNoRecordMessage, successMessageToast, userFullName } from "helpers/common";
import LoadingOverlay from "components/shared/LoadingOverlay";
import CustomEditor from "components/TipTapEditor/CustomeEditor";
import LoadingButton from "components/shared/LoadingButton";
import AppDatePicker from "components/shared/FormComponents/AppDatePicker";
import { Paperclip, User } from "react-feather";
import { useCreateCommentMutation, useCreateNoteMutation, useDeleteCommentMutation, useGetNoteCommentsListQuery, useLazyNoteAcceptSuggestionQuery, useNoteViewQuery, useUpdateCommentMutation, useUpdateNoteMutation } from "store/services/V2/notes";
import AddNotesCollaboratorsModal from "components/Modals/AddNotesCollaborators";
import notesValidation from "./validation";
import { useDispatch, useSelector } from "react-redux";
import AddSuggestionsModal from "components/Modals/AddSuggestions";
import moment from "moment";
import parse from "html-react-parser";
import { extractUploadFileName } from "config/constants";
import { DeleteIcon, EditIcon } from "Assets/icons";
import confirmDialogV2 from "utils/confirmationDialogV2";
import userImg from 'Assets/images/user.png';
import { debounce } from "lodash";
import { initialFilterState, noteCommentsFilter } from "store/slices/filter";

const AddNotesForm = () => {

  const navigate = useNavigate();
  const { clientId, moduleName, clientType, id: noteId } = useParams();
  const profile = useSelector((state) => state?.auth?.user)
  const [suggestionsModal, setSuggestionsModal] = useState(false)
  const [editSuggestionId, setEditSuggestionId] = useState(null)
  const [deleteSuggestionId, setDeleteSuggestionId] = useState(null)
  const [haveAccess, setHaveAccess] = useState(false)
  const [isOwner, setIsOwner] = useState(true)
  const [isNoteEdit, setIsNoteEdit] = useState(false)

  const dispatch = useDispatch();

  const filter = useSelector(state => state?.filter?.noteCommentsFilter);

  const breadcrumbItems = [
    { label: "Notes", path: NOTES_TABLE },
    { label: noteId ? "Edit" : "Add" },

  ];

  const [initialValues, setInitialValues] = useState({ title: '', description: '', date: null, suggestions: [] });
  const [showModal, setShowModal] = useState(false);

  const [createNote, { isLoading: createNotesLoading }] = useCreateNoteMutation();
  const [updateNote, { isLoading: updateNotesLoading }] = useUpdateNoteMutation();
  const { data: noteData, isLoading: noteDataLoading, isFetching: noteDataFetching, refetch } = useNoteViewQuery({ noteId }, { skip: !noteId })
  const [suggestion, { isLoading: suggestionLoading }] = useLazyNoteAcceptSuggestionQuery();

  // manage comments
  const { data: commentsData, isLoading: commentsLoading, isFetching: commentsFetching } = useGetNoteCommentsListQuery({ noteId, ...filter }, { skip: !noteId });
  console.log("commentsData", commentsData)
  const [createComment, { isLoading: createCommentLoading }] = useCreateCommentMutation();
  const [updateComment, { isLoading: updateCommentLoading }] = useUpdateCommentMutation();
  const [deleteComment, { isLoading: deleteCommentLoading }] = useDeleteCommentMutation();


  const handleSubmit = async (values, { resetForm }) => {
    const data = {
      title: values?.title,
      description: values?.description,
      date: values?.date,
      attachments: values?.attachments || [],
      suggestions: values?.suggestions?.length > 0 ? values?.suggestions : [],
      note: ""
    }
    if (values?.therapistData?.length) {
      data.therapistData = values?.therapistData?.map((item) => noteId ? item?.therapist_id : item?.id)
    }
    try {
      const result = noteId ? await updateNote({ data, id: noteId }).unwrap() : await createNote(data).unwrap();
      successMessageToast(result?.message);
      resetForm();
      // navigate(NOTES_TABLE)
      if (!isNoteEdit) {
        navigate(NOTES_TABLE)
      }
      else {
        setIsNoteEdit(false)
      }
    } catch (error) {
      console.error("Error creating note:", error);
    }
  };

  const handleAcceptSuggestion = async (e, descision, suggestionId) => {
    e.stopPropagation();
    const isConfirm = await confirmDialogV2({
      title: `${descision.toUpperCase()} SUGGESTION`,
      message: `Are you sure you want to ${descision} this suggestion?`,
    });
    if (!isConfirm) {
      return;
    }
    try {
      const result = await suggestion({ descision, suggestionId, noteId }).unwrap();
      refetch();
      successMessageToast(result?.message);
    } catch (error) {
      console.log('error', error)
    }
  }

  const handleSaveSuggestion = async (index, suggestion, setFieldValue) => {
      try {
        if(!suggestion) {
          throw new Error("suggestion not found");
        }
        const payload = {
          suggestions: [{
            text: suggestion.text,
            attachments: suggestion.attachments
          }]
        }
        if(suggestion.suggestion_id) {
          // update existing
          const res = await updateComment({
            id: suggestion.suggestion_id,
            noteId,
            data: payload
          }).unwrap();
          successMessageToast(res.message);
        } else {
          // insert new
          const res = await createComment({
            noteId,
            data: payload
          }).unwrap();
          successMessageToast(res.message);
        }
        setEditSuggestionId(null);
        setFieldValue(`suggestions.[${index}].isNew`, false);
      } catch(err) {
        console.error("Error saving suggestion", err);
      }
    }

  const handleRemoveSuggestion = async (e, remove, index, suggestion) => {
    try {
      setDeleteSuggestionId(suggestion?.suggestion_id);
    e.stopPropagation();
    const isConfirm = await confirmDialogV2({
      title: `REMOVE SUGGESTION`,
      message: `Are you sure you want to remove this suggestion?`,
    });
    if (!isConfirm) {
      return;
    }
      if(!suggestion) {
        throw new Error("Suggestion not found");
      }
      if(suggestion?.suggestion_id) {
        // await deleteComment({ id: suggestion?.suggestion_id, noteId }).unwrap();
        await deleteComment({ id: suggestion?.suggestion_id, noteId })
      }
      remove(index);
      setDeleteSuggestionId(null);
    } catch(err) {
      console.error("Error deleting suggestion");
      setDeleteSuggestionId(null);
    }
  }


  const handleDeleteCollaborator = async (e, values, id, setFieldValue) => {
    e.stopPropagation();
    const isConfirm = await confirmDialogV2({
      title: `REMOVE`,
      message: `Are you sure you want to remove this collaborator?`,
    });
    if (!isConfirm) {
      return;
    }
    else {
      if (noteId) {
        const data = {
          therapistData: values?.therapistData?.filter((item) => item?.therapist_id != id)?.map((x) => x?.therapist_id)
        }
        try {
          await updateNote({ data, id: noteId }).unwrap();
        } catch (err) {
          console.error("Error submitting:", err);
        }
      }
      else {
        const filteredTherapists = values?.therapistData?.filter((item) => item?.id != id);
        console.log('filteredTherapists', values?.therapistData, id, filteredTherapists)
        setFieldValue('therapistData', filteredTherapists)
        // handleClose()
      }
    }

  };

  useEffect(() => {
    if (noteData) {
      setInitialValues((prev) => ({
        ...prev,
        title: noteData?.title || "",
        description: noteData?.description || "",
        date: noteData?.date,
        therapistData: noteData?.therapists?.length ? noteData?.therapists : [],
        attachments: noteData?.attachments || [],
        // suggestions: noteData?.suggestions?.length > 0 ? noteData?.suggestions?.map((item) => ({ suggestion_id: item?.id, text: item?.suggestion, attachments: item?.attachments, suggesion_owner: item?.suggesion_owner, createdAt: item?.createdAt })) : [],
        noteOwner: noteData?.noteOwner || null,
        // innerSuggestions: noteData?.suggestions?.length > 0 ? noteData?.suggestions?.map((item) => ({ text: item?.suggestion, attachments: item?.attachments, suggesion_owner: item?.suggesion_owner })) : [],
      }))
    }
    if (noteData) {
      noteData?.noteOwner?.id != profile?.id ? setIsOwner(false) : setIsOwner(true)
    }
  }, [noteData])

  useEffect(() => {
      if(!commentsData?.length) {
        return;
      }
  
      setInitialValues(prev => ({
        ...prev,
        suggestions: commentsData?.length > 0 ? commentsData?.map((item) => ({ suggestion_id: item?.id, text: item?.suggestion, attachments: item?.attachments, suggesion_owner: item?.suggesion_owner, createdAt: item?.createdAt })) : [],
      }))
    }, [commentsData])

  useEffect(() => {
    if (noteId) {
      if (noteData?.noteOwner?.id == profile?.id || noteData?.therapists?.some((item) => item?.therapist_id == profile?.id)) {
        setHaveAccess(true)
      }
      else {
        setHaveAccess(false)
      }
    }
    else {
      setHaveAccess(true)
    }
  }, [profile, noteData])

  const handleFilterChange = (key) => (value) => {
    dispatch(noteCommentsFilter({ ...filter, [key]: value }))
  };

  const resetFilter = () => {
    dispatch(noteCommentsFilter(initialFilterState.noteCommentsFilter));
  };

  const handleSearchChange = useCallback(debounce((value) => {
    handleFilterChange("search")(value);
  }, 500), [handleFilterChange, 500]);

  return (
    <>
      {/* <ConfirmationPop
        confirmation={showModal}
        setConfirmation={setShowModal}
        type="delete"
        confirmHandler={handleDelete}
      /> */}

      <section className={`${styles.addForm} position-relative py-4 addForm h-100`}>
        <Container className="h-100">

          <Row className="">
            <Col lg="6">
              <Breadcrumbs items={breadcrumbItems} />
            </Col>
          </Row>
          {(noteDataLoading) ? <LoadingOverlay /> : <Row className="h-100">
            <Col lg="12" className="my-2">
              {(noteDataFetching || suggestionLoading || commentsLoading || commentsFetching) && <LoadingOverlay blockClicks />}
              <Formik
                initialValues={initialValues}
                validationSchema={notesValidation}
                onSubmit={handleSubmit}
                enableReinitialize
              >
                {({
                  handleSubmit,
                  setFieldValue,
                  isSubmitting,
                  errors,
                  values,
                  touched,
                  setFieldTouched
                }) => (
                  <>
                    {console.log('values', values)
                    }                    <AddNotesCollaboratorsModal
                      show={showModal}
                      setShow={setShowModal}
                      therapists={values?.therapistData || []}
                    // type="delete"
                    // confirmHandler={handleDelete}
                    />
                    <AddSuggestionsModal
                      show={suggestionsModal}
                      setShow={setSuggestionsModal}
                    // type="delete"
                    // confirmHandler={handleDelete}
                    />
                    <Form onSubmit={handleSubmit}>
                      <div className="reports-v2">
                        <div className=" d-flex align-items-center justify-content-between" style={{ borderColor: "#315D99" }}>
                          {/* <h6 className="mb-0 section-title border-bottom-0" style={{ color: "#315D99" }}>{editMode ? "Edit TEMPLATES" : "SAVE A TEMPLATES"}</h6> */}
                        </div>
                        <Row >
                          <Col md="8" className="my-2 name-input-v2">
                            <label
                              htmlFor=""
                              className="discharge-screen-label mt-0"
                            >
                              Notes Title
                              <RequiredFieldAstrick />
                            </label>
                            <AppInputField
                              name="title"
                              className={`${styles.formControl} readonly-box h-auto`}
                              styles={{ border: "1px solid rgba(0,0,0,0.5)" }}
                              disabled={noteId ? noteData?.noteOwner?.id != profile?.id : false}
                            />
                          </Col>
                          <Col md="3" className="my-2 name-input-v2">
                            <label
                              htmlFor=""
                              className="discharge-screen-label mt-0"
                            >
                              Date
                              <RequiredFieldAstrick />
                            </label>
                            <AppDatePicker
                              name="date"
                              className={`${styles.formControl} readonly-box h-auto`}
                              styles={{ border: "1px solid rgba(0,0,0,0.5)" }}
                              placeholder="Enter lesson name"
                              disabled={!isOwner}
                            // disabled={noteId ? noteData?.noteOwner?.id != profile?.id : false}
                            />
                          </Col>
                          <Col md="8" className="mt-2">
                            <label
                              htmlFor=""
                              className="discharge-screen-label mt-0"
                            >
                              Notes
                              <RequiredFieldAstrick />
                            </label>
                            <div className="editor-paren-v2">
                              {
                                noteId ?
                                  <>
                                    <div className="student-details-main-box p-3 shadow my-2" style={{ background: (noteId && !isOwner) ? "rgba(253, 217, 202, 0.31)" : "white", border: "1px solid rgb(61, 160, 170)", borderRadius: 0 }}>
                                      <div className="student-details-main-box-inner">
                                        <div className="student-details-main-box-heading"
                                        >
                                        </div>
                                      </div>
                                      <div style={{ marginBottom: "1rem" }} className="w-100 d-flex justify-content-between">
                                        {/* <p style={{ fontSize: "14px", fontWeight: "700", textTransform: "capitalize" }}>Comment</p> */}
                                        <div className="d-flex gap-2 align-items-center">
                                          <img
                                            // src={noteToShow?.noteOwner?.therapist_detail?.profile_picture === null ? p1 : (noteToShow?.noteOwner?.therapist_detail?.profile_picture == "undefined" ? imageLoader : noteToShow?.noteOwner?.therapist_detail?.profile_picture ? noteToShow?.noteOwner?.therapist_detail?.profile_picture : p1)}
                                            src={values?.noteOwner?.therapist_detail?.profile_picture || userImg}
                                            // src={noteToShow?.noteOwner?.therapist_detail?.profile_picture || p1}
                                            // src={userImg}
                                            alt=""
                                            className="img-fluid object-fit-cover rounded-circle border border-white"
                                            style={{ height: 30, width: 30 }}
                                          />
                                          {userFullName(values?.noteOwner)}
                                        </div>
                                        <div className="">
                                          {/* {item?.createdAt ? dateFormat(item?.createdAt, "MMM DD, YYYY") : moment().format("MMMM DD, YYYY")} */}
                                        </div>
                                      </div>

                                      {
                                        (noteId && !isOwner) || !isNoteEdit ?
                                          <>
                                            <div className="student-details-main-notes" style={{ fontSize: "15px" }}>
                                              <div style={{ borderRadius: 0 }} className="student-details-inner-notes">
                                                {/* <img
                                                      src={noteToShow?.noteOwner?.therapist_detail?.profile_picture === null ? p1 : (noteToShow?.noteOwner?.therapist_detail?.profile_picture == "undefined" ? imageLoader : noteToShow?.noteOwner?.therapist_detail?.profile_picture ? noteToShow?.noteOwner?.therapist_detail?.profile_picture : p1)}
                                                      // src={noteToShow?.noteOwner?.therapist_detail?.profile_picture || p1}
                                                      alt=""
                                                      className="img-fluid object-fit-cover rounded-circle border border-white"
                                                      style={{ height: 30, width: 30 }}
                                                    /> */}
                                                {parse(values?.description || "")}
                                              </div>
                                            </div>
                                            {isValidValue(values?.attachments) && values?.attachments?.length > 0 && (
                                              <div className="mt-3">
                                                <h6 className="text-muted">Attachments</h6>
                                                <ListGroup>
                                                  {values?.attachments?.map((file, index) => (
                                                    <ListGroup.Item key={index} className="d-flex align-items-center py-2">
                                                      <Paperclip size={16} className="me-2 text-secondary" />
                                                      <Link target='_blank' to={file?.attachment_name} className="text-truncate" style={{ maxWidth: '300px' }}>
                                                        {extractUploadFileName(file?.attachment_name)}
                                                      </Link>
                                                    </ListGroup.Item>
                                                  ))}
                                                </ListGroup>
                                              </div>
                                            )}
                                          </> :
                                          <>
                                            <CustomEditor attachmentName={'attachments'} style={{ borderRadius: 0 }} name={`description`} className={'font-17'} />
                                            <LoadingButton
                                              type="submit"
                                              // onClick={() => {
                                              //   setIsNoteEdit(false)
                                              // }}
                                              disabled={!haveAccess || isSubmitting || updateNotesLoading || createNotesLoading}
                                              isLoading={isSubmitting || updateNotesLoading || createNotesLoading}
                                              className="d-flex align-items-center gap-2 justify-content-center discharge-screen btn-outline-danger mt-2"
                                            >
                                              Save
                                            </LoadingButton>
                                          </>

                                      }
                                    </div>
                                    {
                                      (noteId && isOwner) &&
                                      <div className="student-details-main-box-inner">
                                        <div className="student-details-main-box-heading"
                                        >
                                        </div>
                                        <Button
                                          className="border-0 p-0 d-flex align-items-center mb-2"
                                          variant="transparnet"
                                        >

                                          {
                                            !isNoteEdit && <EditIcon onClick={() => setIsNoteEdit(true)} />
                                          }

                                        </Button>
                                      </div>
                                    }
                                  </> : <CustomEditor attachmentName={'attachments'} style={{ borderRadius: 0 }} name={`description`} className={'font-17'} />
                              }

                            </div>
                            {
                              (noteId
                                // && !isOwner
                              ) ?
                                <Col md="12" className="mt-4">
                                  <h6 className="fw-semibold">Collaborator Comments</h6>

                                  {/* Filters */}
                                  <Row className="reports-v2">
                                    <Col lg="6">
                                        <div className="w-100 align-items-center gap-3">
                                            <label className="discharge-screen-label mb-0">Search</label>
                                            <input
                                                onChange={(e) => handleSearchChange(e.target.value)}
                                                // style={{outline: "blue"}}
                                                className={`input-new readonly-box h-auto search-input-filter-v2`}
                                                placeholder="Find comments..."
                                                defaultValue={filter?.search}
                                                type="search"
                                            />
                                        </div>
                                    </Col>
                                    {/* {profile?.role?.id === ROLES.admin && (
                                      <Col md='6'>
                                          <div className="w-100 align-items-center gap-3">
                                          <label className="discharge-screen-label mb-0">Owner</label>
                                          <CommonSelect
                                              placeholder={"Choose one..."}
                                              option={usersList?.map((item) => ({ label: userFullName(item), value: item?.id }))}
                                              onChange={(e) => handleFilterChange("owner")(e)}
                                              value={filter?.school}
                                              // onInputChange={(val) => handleSearch(val)}
                                              isFilterV2
                                              isClearable
                                              styles={{
                                              container: (provided) => ({
                                                  ...provided,
                                                  width: "100%",
                                              }),
                                              }}
                                              isLoading={therapistsListLoading || subAdminsFetching}
                                          />
                                          </div>
                                      </Col>
                                    )} */}
                                </Row>

                                  <FieldArray name="suggestions">
                                    {({ push, remove }) => (
                                      <Row>
                                        {values?.suggestions?.length > 0 ? 
                                        values?.suggestions?.map((item, index) => (
                                          <Col lg="12" key={item.id}>
                                            <>

                                              <div
                                                key={index}
                                                style={{
                                                  // border: "1px solid #ccc",
                                                  // padding: "15px",
                                                  // borderRadius: "8px",
                                                  // marginBottom: "15px",
                                                }}
                                              >
                                                <div className="d-flex justify-content-between">
                                                  <label className="discharge-screen-label mt-0">
                                                  </label>
                                                  {/* <button
                                                type="button"
                                                onClick={() => remove(index)}
                                                className="d-flex align-items-center gap-2 justify-content-center discharge-screen btn-outline-danger"
                                              >
                                                Remove
                                              </button> */}
                                                </div>

                                                {/* <div className="editor-paren-v2 mt-2">
                                              <CustomEditor
                                                style={{ borderRadius: 0 }}
                                                name={`suggestions[${index}].text`}
                                              />
                                            </div> */}
                                                <div className="student-details-main-box p-3 shadow my-2" style={{ background: (editSuggestionId === item?.suggestion_id || item?.isNew) ? "white" : "rgba(253, 217, 202, 0.31)", border: "1px solid rgb(61, 160, 170)", borderRadius: 0 }}>
                                                  <div className="student-details-main-box-inner">
                                                    <div className="student-details-main-box-heading"
                                                    >
                                                    </div>
                                                  </div>
                                                  <div style={{ marginBottom: "1rem" }} className="w-100 d-flex justify-content-between">
                                                    {/* <p style={{ fontSize: "14px", fontWeight: "700", textTransform: "capitalize" }}>Comment</p> */}
                                                    <div className="d-flex gap-2 align-items-center">
                                                      <img
                                                        src={item?.suggesion_owner?.therapist_detail?.profile_picture || userImg}
                                                        alt=""
                                                        className="img-fluid object-fit-cover rounded-circle border border-white"
                                                        style={{ height: 30, width: 30 }}
                                                      />
                                                      {userFullName(item?.suggesion_owner || profile)}
                                                    </div>
                                                    <div className="">
                                                      {item?.createdAt ? dateFormat(item?.createdAt, "MMM DD, YYYY") : moment().format("MMM DD, YYYY")}
                                                    </div>
                                                  </div>

                                                  {
                                                    (editSuggestionId === item?.suggestion_id || item?.isNew) ? <div>
                                                      <div style={{ backgroundColor: "white" }}>
                                                        <CustomEditor name={`suggestions.[${index}].text`} attachmentName={`suggestions.[${index}].attachments`} className="font-17" />
                                                      </div>
                                                      <LoadingButton
                                                        type="button"
                                                        onClick={() => {
                                                          handleSaveSuggestion(index, item, setFieldValue);
                                                        }}
                                                        className="discharge-screen mt-2"
                                                        isLoading={updateCommentLoading || createCommentLoading}
                                                      >
                                                        Save
                                                      </LoadingButton>

                                                    </div> :
                                                      <>
                                                        <div className="student-details-main-notes" style={{ fontSize: "15px" }}>
                                                          <div style={{ borderRadius: 0 }} className="student-details-inner-notes">
                                                            {/* <img
                                                    src={noteToShow?.noteOwner?.therapist_detail?.profile_picture === null ? p1 : (noteToShow?.noteOwner?.therapist_detail?.profile_picture == "undefined" ? imageLoader : noteToShow?.noteOwner?.therapist_detail?.profile_picture ? noteToShow?.noteOwner?.therapist_detail?.profile_picture : p1)}
                                                    // src={noteToShow?.noteOwner?.therapist_detail?.profile_picture || p1}
                                                    alt=""
                                                    className="img-fluid object-fit-cover rounded-circle border border-white"
                                                    style={{ height: 30, width: 30 }}
                                                  /> */}
                                                            {parse(item?.text || "")}
                                                          </div>
                                                        </div>
                                                        {
                                                          (editSuggestionId !== item?.suggestion_id && !item?.isNew) &&
                                                          <Col lg="12">
                                                            {isValidValue(item?.attachments) && item?.attachments?.length > 0 && (
                                                              <div className="mt-3">
                                                                <h6 className="text-muted">Attachments</h6>
                                                                <ListGroup>
                                                                  {item?.attachments?.map((file, index) => (
                                                                    <ListGroup.Item key={index} className="d-flex align-items-center py-2">
                                                                      <Paperclip size={16} className="me-2 text-secondary" />
                                                                      <Link target='_blank' to={file?.attachment_name} className="text-truncate" style={{ maxWidth: '300px' }}>
                                                                        {extractUploadFileName(file?.attachment_name)}
                                                                      </Link>
                                                                    </ListGroup.Item>
                                                                  ))}
                                                                </ListGroup>
                                                              </div>
                                                            )}
                                                          </Col>
                                                        }
                                                      </>
                                                  }

                                                </div>
                                                <div className="student-details-main-box-inner">
                                                  <div className="student-details-main-box-heading"
                                                  >
                                                  </div>
                                                  <Button
                                                    className="border-0 p-0 d-flex align-items-center mb-2"
                                                    variant="transparnet"
                                                  >

                                                    {
                                                      (item?.suggesion_owner?.id == profile?.id && editSuggestionId !== item?.suggestion_id && !item?.isNew) ? <EditIcon onClick={() => setEditSuggestionId(item?.suggestion_id)} className="flex-shrink-0" /> : null
                                                    }

                                                    {(isOwner || item?.suggesion_owner?.id == profile?.id) && (
                                                      deleteSuggestionId === item?.suggestion_id && deleteCommentLoading ? (
                                                        <LoadingIndicator inline={true} size={7} />
                                                      ):(
                                                        <DeleteIcon className="flex-shrink-0" onClick={(e) => handleRemoveSuggestion(e, remove, index, item)} />
                                                      )
                                                    )}


                                                  </Button>
                                                </div>
                                              </div>


                                              {/* <button
                                          type="button"
                                          className="btn btn-sm btn-outline-primary mt-2 blue-discharge-screen-btn"
                                          onClick={() => push({ text: "" })}
                                        >
                                          + Add Suggestion
                                        </button> */}
                                            </>
                                          </Col>
                                        )):(
                                          <Col lg="12" className="my-2">
                                            <NoRecordMessage msg="Comments have not been added." className="mt-2" />
                                          </Col>
                                        )
                                      }
                                        <Col lg="6">
                                          <button
                                            type="button"
                                            className="btn btn-sm btn-outline-primary mt-2 blue-discharge-screen-btn"
                                            onClick={() => push({ text: "", isNew: true })}
                                            disabled={updateNotesLoading || createNotesLoading || createCommentLoading || updateCommentLoading || deleteCommentLoading}
                                          >
                                            Add Comment
                                          </button>
                                        </Col>
                                      </Row>
                                    )}
                                  </FieldArray>
                                </Col> :

                                values?.suggestions?.length > 0 ? values?.suggestions?.map((item, index) => (
                                  <Row key={item.id}>
                                    <Col md="12" className="">
                                      {
                                        index == 0 &&
                                        <h6 style={{ fontSize: "18px" }} className="fw-semibold mt-4 mb-3">Collaborator Comments</h6>
                                      }                                    <div className="student-details-main-box p-3 shadow my-2" style={{ background: /*"rgb(253 217 202 / 31%)" */ "white", border: "1px solid rgb(61, 160, 170)" }}>
                                        <div className="student-details-main-box-inner">
                                          <div className="student-details-main-box-heading"
                                          >
                                          </div>
                                        </div>
                                        <div className="w-100 d-flex justify-content-between">
                                          {/* <p style={{ fontSize: "14px", fontWeight: "700", textTransform: "capitalize" }}>Comment {index + 1}</p> */}
                                          <div style={{ marginBottom: "1rem" }} className="d-flex gap-2 align-items-center">
                                            <img
                                              // src={noteToShow?.noteOwner?.therapist_detail?.profile_picture === null ? p1 : (noteToShow?.noteOwner?.therapist_detail?.profile_picture == "undefined" ? imageLoader : noteToShow?.noteOwner?.therapist_detail?.profile_picture ? noteToShow?.noteOwner?.therapist_detail?.profile_picture : p1)}
                                              src={item?.suggesion_owner?.therapist_detail?.profile_picture || userImg}
                                              // src={noteToShow?.noteOwner?.therapist_detail?.profile_picture || p1}
                                              alt=""
                                              className="img-fluid object-fit-cover rounded-circle border border-white"
                                              style={{ height: 30, width: 30 }}
                                            />
                                            {userFullName(item?.suggesion_owner)}
                                          </div>
                                          <div className="">
                                            {item?.createdAt ? dateFormat(item?.createdAt, "MMM DD, YYYY") : ""}
                                          </div>
                                        </div>

                                        <div className="student-details-main-notes" style={{ fontSize: "15px" }}>
                                          <div style={{ borderRadius: 0 }} className="student-details-inner-notes">
                                            {/* <img
                                              src={noteToShow?.noteOwner?.therapist_detail?.profile_picture === null ? p1 : (noteToShow?.noteOwner?.therapist_detail?.profile_picture == "undefined" ? imageLoader : noteToShow?.noteOwner?.therapist_detail?.profile_picture ? noteToShow?.noteOwner?.therapist_detail?.profile_picture : p1)}
                                              // src={noteToShow?.noteOwner?.therapist_detail?.profile_picture || p1}
                                              alt=""
                                              className="img-fluid object-fit-cover rounded-circle border border-white"
                                              style={{ height: 30, width: 30 }}
                                            /> */}
                                            {parse(item?.text || "")}
                                          </div>
                                        </div>
                                        {isValidValue(item?.attachments) && item?.attachments?.length > 0 && (
                                          <div className="mt-3">
                                            <h6 className="text-muted">Attachments</h6>
                                            <ListGroup>
                                              {item?.attachments?.map((file, index) => (
                                                <ListGroup.Item key={index} className="d-flex align-items-center py-2">
                                                  <Paperclip size={16} className="me-2 text-secondary" />
                                                  <Link target='_blank' to={file?.attachment_name} className="text-truncate" style={{ maxWidth: '300px' }}>
                                                    {extractUploadFileName(file?.attachment_name)}
                                                  </Link>
                                                  {/* {
                                                    <Button
                                                      variant=""
                                                      size="sm"
                                                      className="ms-auto text-danger"
                                                      onClick={() => handleRemoveAttachment(index)}
                                                    >
                                                      Remove
                                                    </Button>
                                                  } */}
                                                </ListGroup.Item>
                                              ))}
                                            </ListGroup>
                                          </div>
                                        )}
                                        {/* <div className="d-flex justify-content-end gap-2">
                                          <button
                                            onClick={(e) => { handleAcceptSuggestion(e, "reject", item?.suggestion_id) }}
                                            style={{ backgroundColor: "white" }}
                                            type="button"
                                            className="d-flex themePurple mt-2 align-items-center gap-2 justify-content-center discharge-screen"
                                          // disabled={isSubmitting || suggestionLoading}
                                          // isLoading={submitReportLoading || submitting}
                                          >
                                            Reject
                                          </button>
                                          <button
                                            onClick={(e) => { handleAcceptSuggestion(e, "accept", item?.suggestion_id) }}
                                            type="button"
                                            // disabled={isSubmitting || suggestionLoading}
                                            className="d-flex mt-2 align-items-center gap-2 justify-content-center discharge-screen"
                                          // disabled={isFetching || submitting || copyReportLoading}
                                          // isLoading={submitReportLoading || submitting}
                                          >
                                            Accept
                                          </button>
                                        </div> */}
                                      </div>
                                    </Col>
                                  </Row>
                                )) : <Col lg="12">
                                  {
                                    noteId &&
                                    <ReportsNoRecordMessage msg="Comments have not been added." className="m-0" />
                                  }
                                </Col>
                            }
                          </Col>
                          <Col md="4" className="mt-2">
                            <div style={{ borderTop: "1px solid rgb(94 122 162)", paddingTop: "23px" }} className="editor-paren-v2">
                              <div style={{ width: "250px" }}>
                                <h6 className="mb-3 fw-semibold">Collaborators</h6>
                                <ListGroup variant="flush">
                                  {values?.therapistData?.map((item, index) => (
                                    <ListGroup.Item key={index} className="border-0 px-0 py-2">
                                      <table className="w-100">
                                        <tbody>
                                          <tr>
                                            {/* User info */}
                                            <td className="align-middle">
                                              <div className="d-flex align-items-center gap-2">
                                                {(item?.therapist?.therapist_detail?.profile_picture ||
                                                  item?.therapist_detail?.profile_picture) ? (
                                                  <img
                                                    src={
                                                      item?.therapist?.therapist_detail?.profile_picture ||
                                                      item?.therapist_detail?.profile_picture
                                                    }
                                                    alt=""
                                                    className="img-fluid object-fit-cover rounded-circle border border-white"
                                                    style={{ width: 30, height: 30 }}
                                                  />
                                                ) : (
                                                  <User size={24} className="text-secondary" />
                                                )}

                                                <span>{userFullName(item?.therapist || item)}</span>
                                              </div>
                                            </td>

                                            {/* Delete icon */}
                                            {isOwner && (
                                              <td
                                                className="cursor-pointer align-middle text-end"
                                                style={{ width: "40px" }}
                                              >
                                                <DeleteIcon
                                                  onClick={(e) =>
                                                    handleDeleteCollaborator(
                                                      e,
                                                      values,
                                                      noteId ? item?.therapist_id : item?.id,
                                                      setFieldValue
                                                    )
                                                  }
                                                />
                                              </td>
                                            )}
                                          </tr>
                                        </tbody>
                                      </table>
                                    </ListGroup.Item>

                                  ))}

                                </ListGroup>
                                <div
                                  onClick={() => {
                                    if (noteData?.noteOwner?.id == profile?.id || !noteId) setShowModal(true);
                                  }}
                                  style={{
                                    border: "1px solid #93278F",
                                    padding: "10px 12px",
                                    marginTop: "10px",
                                    cursor: noteId ? noteData?.noteOwner?.id == profile?.id ? "pointer" : "not-allowed" : "pointer",
                                    opacity: noteId ? noteData?.noteOwner?.id == profile?.id ? 1 : 0.5 : 1,
                                    pointerEvents: noteId ? noteData?.noteOwner?.id == profile?.id ? "auto" : "none" : "auto",
                                  }}
                                >
                                  <h2 className="themePurple mb-0 proxima-regular forteen text-center">
                                    Add/Manage Collaborators
                                  </h2>
                                </div>

                              </div>
                            </div>
                          </Col>

                          <Col lg="6"></Col>
                          <Col lg="6 my-2">
                            <div className="btnWrpper mt-2 d-flex justify-content-end">
                              <LoadingButton
                                type="submit"
                                className="blue-discharge-screen-btn"
                                disabled={!haveAccess || isSubmitting || updateNotesLoading || createNotesLoading}
                                isLoading={isSubmitting || updateNotesLoading || createNotesLoading}
                              >
                                Save
                              </LoadingButton>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Form>
                  </>
                )}
              </Formik>
            </Col>
          </Row>}
        </Container>
      </section>
    </>
  );
};

export default AddNotesForm;
